import initCarousel from '../helpers/carousel';
import { unitlessBreakpoints } from '../helpers/breakpoints';

export default class DynamicFeaturedFeed {
  constructor(section) {
    this.el = section.el;

    initCarousel(
      this.el,
      {
        type: 'loop',
        perPage: 1,
        gap: '1rem',
        pagination: false,
        focus: 'center',
        padding: {
          left: '10%',
          right: '10%',
        },
        mediaQuery: 'min',
        breakpoints: {
          [unitlessBreakpoints.sm]: {
            perPage: 2,
          },
          [unitlessBreakpoints.lg]: {
            perPage: 3,
            padding: 0,
          },
        },
      },
      true,
    );
  }
}
